import { isUndNullEmp } from '../../helpers/main.js';

export class BackupReview {
    constructor(
        _id = 0,
        _customerId = 0,
        _dateBegin = '',
        _isActive = false,
        _commentary = '',
        _register = '',
    ) {
        this.id = _id;
        this.customerId = _customerId;
        this.dateBegin = _dateBegin;
        this.isActive = _isActive;
        this.commentary = _commentary;
        this.register = _register;
    }

    static getClasscustomerId = () => {
        return 'BackupReview - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Id: 0,
                    CustomerId: 0,
                    DateBegin: 10,
                    IsActive: 0,
                    Commentary: 2,
                    Register: 10,
                },
                max: {
                    Id: 450,
                    CustomerId: 450,
                    DateBegin: 30,
                    IsActive: 1,
                    Commentary: 1000,
                    Register: 30,
                },
            };
        } else {
            return {
                min: {
                    id: 0,
                    customerId: 0,
                    dateBegin: 10,
                    isActive: 0,
                    commentary: 2,
                    register: 10,
                },
                max: {
                    id: 450,
                    customerId: 450,
                    dateBegin: 30,
                    isActive: 1,
                    commentary: 1000,
                    register: 30,
                },
            };
        }
    }

    // static userIdFullPath = ({userId = '', subMethod = ''} = {}) => {
    //     let response = getResponse({ type: 0 });
    //     const currentMethod = 'BackupReview / userIdFullPath';
    //     try {
    //         if(!isUndNullEmp({data: userId, subMethod: currentMethod})?.result){
    //             userId = userId.replace('~/Images/UserIds/BackupReview/', `${settings?.backend?.urls?.imageUserIds}${settings?.backend?.urls?.paymentInformations}/`);
    //             response.result = `${settings?.backend?.urls?.api}${userId}`
    //         } else {
    //             response.result = `${settings?.backend?.urls?.api}${settings?.images?.noImage}`;
    //         }
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
    //             response.msgText += `Sub method: ${subMethod}<br/>`;
    //         }
    //         response.msgText += `Error: ${ex?.message}<br/>`;
    //     }
    //     return response;
    // }

    static getClass = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: BackupReview.getClasscustomerId() })?.result) {
            if (upperCase) {
                return new BackupReview(
                    obj.Id,
                    obj.CustomerId,
                    obj.DateBegin,
                    obj.IsActive,
                    obj.Commentary,
                    obj.Register,
                );
            } else {
                return new BackupReview(
                    obj.id,
                    obj.customerId,
                    obj.dateBegin,
                    obj.isActive,
                    obj.commentary,
                    obj.register,
                );
            }
        } else {
            return new BackupReview();
        }
    }
}